import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { BuildingObjectsComponent } from './building-objects/building-objects.component';
import { BuildingWorksComponent } from './building-works/building-works.component';
import { InfrastructureDevicesComponent } from './infrastructure-devices/infrastructure-devices.component';
import { LaneOccupancyPortalRoutingModule } from './lane-occupancy-portal-routing.module';
import { LaneOccupancyPortalComponent } from './lane-occupancy-portal.component';

@NgModule({
  declarations: [
    LaneOccupancyPortalComponent,
    InfrastructureDevicesComponent,
    BuildingObjectsComponent,
    BuildingWorksComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    LaneOccupancyPortalRoutingModule,
  ],
})
export class LaneOccupancyPortalModule {}
